// extracted by mini-css-extract-plugin
module.exports = {"Switcher":"ManagePlanPage_Switcher__1uEWt","Intro":"ManagePlanPage_Intro__3-vwU","ErrorCode":"ManagePlanPage_ErrorCode__3NAEi","Plans":"ManagePlanPage_Plans__iC9TZ"};